<template>
<div class="center-pie-chart">
  <div class="title">运输货物类型占比</div>
  <dv-active-ring-chart class="pie-chart" :config="config" style="width:314px; height:291px;" />
</div>
</template>

<script>
import data from '../js/pieChartData'
import { getType } from '../../../api/colunm3'
export default {
  data () {
    return {
      config: data
    }
  },

  created () {
    this.getData()
  },

  methods: {
    getData () {
      getType().then(res => {
        this.config.data = res
        this.config = { ...this.config }
        this.timer && clearInterval(this.timer)
        this.timer = setTimeout(this.getData, 1000 * 15)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.center-pie-chart {
  position: relative;
  width: 314px;
  height: 291px;
  .title {
    position: absolute;
    left: 15px;
    top: 10px;
    color: #34DEE5;
    font-size: 21px;
    font-weight: bold;
  }
  .pie-chart {
    position: relative;
    top: 0;
    left: 0;
    transform: translateY(15px);
  }
}
/deep/ .active-ring-name {
  width: 200px !important;
  overflow: initial !important;
  white-space: normal !important;
  font-size: 20px !important;
}
</style>